// App.js
import React from "react";
import { Helmet } from "react-helmet";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LessonsSection from "./components/LessonsSection";
import DonationSection from "./components/DonationSection";

const App = () => {
  return (
    <div className="App">
     <Helmet>
        <meta charSet="utf-8" />
        <title>React30</title>
        <meta
          name="description"
          content="Master the core fundamentals of React in 30 articles. Start learning and support React30."
        />
        <meta
          name="keywords"
          content="React, ReactJS, Learn React, React Fundamentals"
        />
        <meta name="author" content="SaurabhNative" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        {/* Open Graph Meta Tags (for social sharing) */}
        <meta property="og:title" content="React30" />
        <meta
          property="og:description"
          content="Master the core fundamentals of React in 30 articles. Start learning and support React30."
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/dk22rcdch/image/upload/v1705837387/React30/rs4ah2rzs0jbqftcbtqb.jpg"
        />
        <meta property="og:url" content="https://react30.netlify.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        {/* Twitter Meta Tags (for Twitter card) */}
        <meta name="twitter:card" content="React30" />
        <meta name="twitter:site" content="@saurabhnative" />
        <meta name="twitter:title" content="React30" />
        <meta
          name="twitter:description"
          content="Master the core fundamentals of React in 30 articles. Start learning and support React30."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/dk22rcdch/image/upload/v1705837387/React30/rs4ah2rzs0jbqftcbtqb.jpg"
        />
      </Helmet>
      <Header />
      <HeroSection />
      <LessonsSection />
      <DonationSection />
    </div>
  );
};

export default App;
